import React from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const InventoryTrendChart = ({ data, timeRange, showByCategory = false }) => {
  // Process data based on time range
  const processData = () => {
    // This is a simplified example - in a real app you would process actual historical data
    const categories = [...new Set(data.map(item => item.category))];
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    
    if (showByCategory) {
      return {
        labels: categories,
        datasets: [{
          label: 'Inventory Value (₹)',
          data: categories.map(category => 
            data.filter(item => item.category === category)
              .reduce((sum, item) => sum + (item.price_per_unit * item.current_quantity), 0)
          ),
          backgroundColor: 'rgba(59, 130, 246, 0.5)',
          borderColor: 'rgba(59, 130, 246, 1)',
          borderWidth: 2
        }]
      };
    }

    return {
      labels: months.slice(0, timeRange === '7d' ? 1 : timeRange === '30d' ? 3 : timeRange === '90d' ? 6 : 12),
      datasets: [{
        label: 'Total Inventory Value (₹)',
        data: months.slice(0, timeRange === '7d' ? 1 : timeRange === '30d' ? 3 : timeRange === '90d' ? 6 : 12)
          .map((_, i) => {
            // Simulate some variation in the data
            const baseValue = data.reduce((sum, item) => 
              sum + (item.price_per_unit * item.current_quantity), 0);
            return baseValue * (0.9 + Math.random() * 0.2);
          }),
        borderColor: 'rgb(75, 192, 192)',
        backgroundColor: 'rgba(75, 192, 192, 0.5)',
        tension: 0.1
      }]
    };
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            return `₹${context.raw.toLocaleString('en-IN')}`;
          }
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: function(value) {
            return `₹${value.toLocaleString('en-IN')}`;
          }
        }
      }
    }
  };

  return <Line data={processData()} options={options} />;
};

export default InventoryTrendChart;